import React, {useEffect, useState} from 'react';
import ReactSelect from 'react-select/async';
import ReactDatepicker from 'react-datepicker';

import {Alert} from '../components/Alert';
import {LoadingIndicator} from '../components/LoadingIndicator';
import {parseJSON} from '../_helpers/fetch';
import {Etl} from '../_services/Etl';
import {User} from '../_services/User';

const debounce = require('debounce-promise');

/**
 * NOTE: this does not belong here.. it should be it's own standalone app
 */

export const PaOnboardingManagerList = () => {
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [workflows, setWorkflows] = useState<any>();

    // get employees needing completing by current user
    useEffect(() => {
        setIsLoading(true);

        const requestHeaders: any = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };
        const baseUrl = '/p/flow';

        fetch(baseUrl + '/api/paonboarding/workflows', {
            headers: {
                ...requestHeaders,
                'Authorization': 'Bearer ' + User.getInstance().getAuthToken()
            },
            method: 'GET',
        })
            .then(parseJSON)
            .then(response => {
                if (response.ok) {
                    setWorkflows(response?.json?.entries);
                } else {
                    throw Error('');
                }
            })
            .catch((e) => {
                setErrorMessage(e?.message || e || 'Unrecoverable error. Please refresh the page and try again. If the error persists, open a support ticket using the menu above');
            })
            .finally(() => {
                setIsLoading(false);
            })
    }, []);

    return (
        <>
            {isLoading && <LoadingIndicator/>}
            <h1>PA Orientation Program</h1>
            {errorMessage && <Alert type={'danger'} message={errorMessage}/>}

            {workflows && workflows?.length === 0 &&
                <p><em>You have no active new joiners in process</em></p>
            }

            {workflows && workflows?.length > 0 &&
                <>
                    <table className="table table-sm table-bordered">
                        <thead>
                        <tr>
                            <th>Employee</th>
                            <th>Start Date</th>
                            <th style={{width: '300px'}}>Buddy</th>
                            <th>Current Step</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {workflows.map(e => (
                            <tr>
                                <td style={{minWidth: '300px'}}>
                                    <div>{e['3']} {e['4']}</div>
                                    <div>{e['5']}</div>
                                </td>
                                <td>{e['10']}</td>
                                <td>{e['11']}</td>
                                <td>{e.workflow_step}</td>
                                <td>
                                    <a href={'/p/flow/entry/' + e.id}>View</a>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </>
            }
        </>
    );
}